<div class="main-layout-wrapper flex flex-column">
  <main-header>

  </main-header>
  <div class="body-content flex flex-column">
    <div class="main-breadcrumb-wrapper flex  align-content-start align-items-center gap-12">
      <button *ngIf="isMobile" class="menu-button" (click)="toggleSidebar()">
        <i class="pi pi-bars"></i>
      </button>
      <main-breadcrumb></main-breadcrumb>
    </div>
    <div class="main-layout-content flex flex-row">
      <!-- Sidebar -->
      <main-side-menu
        *ngIf="!isMobile"
        [(isCollapsed)]="isCollapsed">
      </main-side-menu>

      <p-dialog [resizable]="false" [draggable]="false"
        [(visible)]="isSidebarOpen"
        [modal]="true"
        [closable]="true"
        [dismissableMask]="true"
        [style]="{ position: 'fixed',
         left: '0',
         top: '0',
         maxHeight: 'unset',
          height: '100%',
          width: '300px',
          }"
        [contentStyle]="{ height: '100%', padding: '0', overflow: 'auto'}"
        header="{{'sidebar.menu' | translate }}"
        (onHide)="closeSidebar()">
        <main-side-menu
          [(isCollapsed)]="isCollapsed"
          [isMobile]="true"
          (onClickMenu)="closeSidebar()"
        ></main-side-menu>
      </p-dialog>

      <!-- Main Content -->
      <div class="router-content"
           [style.width]="isMobile ? '100%' : (!isCollapsed ? 'calc(100% - 300px)' : 'calc(100% - 100px)')">
        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>
